module.exports = __webpack_public_path__ + "img/cooperation11.1fdcfc20.png";